import {SPECIAL_POST_SLUGS} from '../../../../../core/entities/columns/constants';
import {formatDate} from '../../../../../shared/services/formatDate';
import {useMediaQuery} from '../../../../../shared/services/useMediaQuery';
import {ColumnTag} from './ColumnTag';

const SPECIAL_POST_MAIN_IMAGES: Record<string, string> = {
  [SPECIAL_POST_SLUGS.COLUMN_1]:
    '/next-image/columns/postMainImage/special_column_1.jpg',
  [SPECIAL_POST_SLUGS.COLUMN_2]:
    '/next-image/columns/postMainImage/special_column_2.jpg',
  [SPECIAL_POST_SLUGS.COLUMN_3]:
    '/next-image/columns/postMainImage/special_column_3.jpg',
  [SPECIAL_POST_SLUGS.COLUMN_4]:
    '/next-image/columns/postMainImage/special_column_4.jpg',
  [SPECIAL_POST_SLUGS.COLUMN_5]:
    '/next-image/columns/postMainImage/special_column_5.jpg',
  [SPECIAL_POST_SLUGS.COLUMN_6]:
    '/next-image/columns/postMainImage/special_column_6.jpg',
  [SPECIAL_POST_SLUGS.COLUMN_7]:
    '/next-image/columns/postMainImage/special_column_7.jpg',
  [SPECIAL_POST_SLUGS.COLUMN_8]:
    '/next-image/columns/postMainImage/special_column_8.jpg',
  [SPECIAL_POST_SLUGS.COLUMN_9]:
    '/next-image/columns/postMainImage/special_column_9.jpg',
  [SPECIAL_POST_SLUGS.COLUMN_10]:
    '/next-image/columns/postMainImage/special_column_10.jpg',
  [SPECIAL_POST_SLUGS.ENGINEER]:
    '/next-image/columns/postMainImage/special_column_engineer.jpg',
  [SPECIAL_POST_SLUGS.INDEX]:
    '/next-image/columns/postMainImage/special_column_index.jpg',
  [SPECIAL_POST_SLUGS.OVERSEAS]:
    '/next-image/columns/postMainImage/special_column_overseas.jpg',
  [SPECIAL_POST_SLUGS.QUIZ]:
    '/next-image/columns/postMainImage/special_column_quiz.jpg',
  [SPECIAL_POST_SLUGS.CASE_INTERVIEW]:
    '/next-image/columns/postMainImage/special_column_case_interview.jpg',
  [SPECIAL_POST_SLUGS.SUMMER_INTERN]:
    '/next-image/columns/postMainImage/special_column_summer_intern.png',
  [SPECIAL_POST_SLUGS.WINTER_INTERN]:
    '/next-image/columns/postMainImage/special_column_winter_intern.jpg',
  [SPECIAL_POST_SLUGS.ENGINEER_INTERN]:
    '/next-image/columns/postMainImage/special_column_engineer_intern.jpg',
};

type Props = {
  slug: string;
  title: string;
  datetime: string;
  tags: string[];
};

export const SpecialColumnPostTitle: React.FC<Props> = ({
  slug,
  title,
  datetime,
  tags,
}) => {
  const {isPC} = useMediaQuery();

  return (
    <div className="mb-12">
      <div className="w-full bg-white-1 p-16">
        <div className="flex justify-between items-start mb-16">
          <div className="flex justify-start items-start flex-wrap w-[calc(100% - 55px)]">
            {tags.map((tag, index) => (
              <div className="mb-4" key={index}>
                <ColumnTag tag={tag} />
              </div>
            ))}
          </div>
        </div>
        <h1 className="text-black-1 text-xl font-bold leading mb-4">{title}</h1>
        <p className="text-sm text-black-3 text-right">
          {formatDate(datetime)}
        </p>
      </div>
      {isPC && SPECIAL_POST_MAIN_IMAGES[slug] && (
        <img src={SPECIAL_POST_MAIN_IMAGES[slug]} alt={title} />
      )}
    </div>
  );
};
